import { render, staticRenderFns } from "./DynamicCheckboxes.vue?vue&type=template&id=2b0f7642"
import script from "./DynamicCheckboxes.vue?vue&type=script&lang=js"
export * from "./DynamicCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports